<template>
  <div class="containerProduct">
    <v-row>
      <v-col class="pr-0 pr-sm-2" v-if="getIsEmployeeUser">
        <BaseFormSelect
          id-element="takerQuotation"
          placeholder="Escolher"
          label-text="Empresas"
          v-model="selectedValueStepModality.taker"
          :items="getListEconomicGroup"
          item-text="nome"
          item-value="id"
          required
          :return-object="true"
        />
      </v-col>
      <v-spacer />
      <QuotationFloatActionButton
        v-if="getUserIsGuest || !getIsEmployeeUser"
        :message="infoMessage"
      />
    </v-row>
    <QuotationSelectModality
      @modality="getModality"
      :model="selectedValueStepModality.modality"
      :list="listModalities"
      title="PRODUTO"
    />
    <QuotationSelectSubModality
      @subModality="getSubModality"
      v-if="selectedValueStepModality.modality"
      :model="selectedValueStepModality.subModality"
      :list="this.listSubModality"
      title="CULTURA"
    />
    <BaseFooter>
      <v-row>
        <v-spacer />
        <v-col cols="12" sm="5" md="3">
          <BaseButton
            v-html="'CANCELAR SOLICITAÇÃO'"
            class="white--text pink"
            width="100%"
            @click="cancelQuotation"
          />
        </v-col>
      </v-row>
    </BaseFooter>
  </div>
</template>
<script>
import QuotationSelectModality from "../components/QuotationSelectModality";
import QuotationSelectSubModality from "../components/QuotationSelectSubModality.vue";
import { mapState, mapActions } from "vuex";
import { QuotationMixin } from "@/mixins/NewQuotationMixin";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import QuotationFloatActionButton from "../components_agro/QuotationFloatActionButton.vue";
export default {
  name: "QuotationStepProduct",
  data: () => ({
    selectedValueStepModality: {},
    listSubModality: [],
    listModalities: []
  }),
  mounted() {
    this.getValueStepModality();
    window.addEventListener("beforeunload", this.handleBeforeUnload);
    this.disableBackButton();
  },
  beforeUnmount() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  },
  components: {
    QuotationSelectModality,
    QuotationSelectSubModality,
    QuotationFloatActionButton
  },
  mixins: [QuotationMixin, LoadingRequest],
  computed: {
    ...mapState("quotation", ["listModality", "listUserTaker"]),
    ...mapState("me", ["userIsEmployee", "userIsGuest"]),
    nextQuotationStep() {
      return {
        name: "quotation step risk",
        step: 2
      };
    },
    getUserIsGuest() {
      return this.userIsGuest;
    },
    getIsEmployeeUser() {
      return this.userIsEmployee;
    },
    getListEconomicGroup() {
      let list = [];
      this.listUserTaker.forEach(eg => {
        if (!list.find(x => x.id == eg.grupo.id)) {
          list.push(eg.grupo);
        }
      });
      return list;
    },
    infoMessage() {
      return "Olá, seja bem vindo ao sistema de cotação Agro da Lockton. Comece selecionando o produto e a cultura.";
    },
    getEconomicGroupId() {
      return this.selectedValueStepModality.taker.id;
    }
  },
  created() {
    this.withLoading(this.fetchTaker());
  },
  methods: {
    getFormForNavigation() {
      return this.selectedValueStepModality;
    },
    ...mapActions("quotation", [
      "requestEgModalities",
      "requestEgSubmodalities",
      "requestOptionsQuotation",
      "requestUserTaker"
    ]),
    ...mapActions(["hasLoading", "showAlertNotification"]),
    // Lógica a ser executada antes da descarga da página pelo navegador
    handleBeforeUnload(event) {
      event.returnValue = "Deseja realmente sair?";
    },
    /*Essa função é feito para manipular o histórico de navegação sem realmente alterar a página, adicionando uma
    entrada nula ao histórico, criando assim a ilusão de desativar o botão de voltar do navegador.*/
    disableBackButton() {
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", () => {
        history.pushState(null, null, document.URL);
      });
    },
    async fetchModalities() {
      this.listModalities = [];
      this.withLoading(await this.requestEgModalities(this.getEconomicGroupId));
      this.listModalities = this.listModality;
    },
    async fetchTaker() {
      await this.requestUserTaker();
      if (!this.getIsEmployeeUser) {
        this.setTaker();
      }
    },
    cancelQuotation() {
      this.$emit("cancel");
    },
    fetchSubModalities(item) {
      this.listSubModality = item.submodalidades;
      this.selectedValueStepModality.modality = item;
      const element = document.getElementById("submodality");
      if (element) {
        element.scrollIntoView();
      }
    },
    getValueStepModality() {
      // Caso retorne os passos anteriores, preciso pegar as informações
      // que já foram selecionadas.
      this.selectedValueStepModality = { ...this.form };
    },
    setTaker() {
      let paramGE = this.$route.query.group_id;

      if (paramGE != null) {
        this.selectedValueStepModality.taker = this.getListEconomicGroup.find(
          x => x.id == paramGE
        );
      } else {
        this.selectedValueStepModality.taker = this.getListEconomicGroup[0];
      }
    },
    getModality(item) {
      this.selectedValueStepModality.subModality = null;
      this.fetchSubModalities(item);
    },
    getSubModality(item) {
      this.selectedValueStepModality.subModality = item;
      this.withLoading(
        this.requestOptionsQuotation(item.id).then(item => {
          this.$emit("updateOptions", item);
          this.$emit(
            "updateStep",
            this.payloadQuotation(
              this.selectedValueStepModality,
              this.nextQuotationStep
            )
          );
          const element = document.getElementById("emission");
          if (element) {
            element.scrollIntoView();
          }
        })
      );
    }
  },
  watch: {
    "selectedValueStepModality.taker"(newValue) {
      if (newValue) {
        this.fetchModalities();
      }
    }
  },
  props: {
    form: {
      type: Object
    },
    optionsQuotation: {
      type: Object
    }
  }
};
</script>
<style lang="sass">
.containerProduct
  width: 80% !important
  margin: 0 auto !important
.quotation-title
  font-size: 18px
</style>
